angular.module('dealerware.web.smartling')
  .directive('dealerwareSmartlingContext', function (
    SmartlingOrganizationId, AppConfig
  ) {
    var template = `
      <script>
        (function (window, organizationId, env) {
          try {
            var h = document.getElementsByTagName('head')[0];
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = 1;
            s.crossOrigin = 'anonymous';
            s.src = '//d2c7xlmseob604.cloudfront.net/tracker.min.js';
            s.onload = function () {
              if (env === 'qa') {
                window.SmartlingContextTracker.init({ orgId: organizationId });
              }
            };
            h.insertBefore(s, h.firstChild);
          } catch (ex) {
          }
        })(window, '${SmartlingOrganizationId}', '${AppConfig.environment}')
      </script>
    `;

    return {
      restrict: 'E',
      replace: true,
      link: function (_, $element) {
        $element.replaceWith(angular.element(template));
      }
    };
});
